export const defaultAlertError = (requestError, dispatchAlert, customKey) => {
  if (requestError.response) {
    const error = requestError.response.data.errors;
    let errorMessage = null;

    if (customKey) {
      errorMessage = error[customKey];
    } else if (error && typeof error === 'object') {
      const errorKey = Object.keys(error)[0] || 'base';
      errorMessage = error[errorKey];
    }

    if (error) {
      dispatchAlert({
        type: 'error',
        message: errorMessage || 'Ocurrió un error, intente más tarde'
      });
      return;
    }
  }
  dispatchAlert({
    type: 'error',
    message: 'Ocurrió un error, intenta de nuevo'
  });
};

export const defaultAlertSuccess = (requestSuccess, dispatchAlert, key) => {
  if (requestSuccess) {
    const success = requestSuccess;
    dispatchAlert({
      type: 'success',
      message:
        success.alertMessage ||
        success[key] ||
        success.message ||
        'Consulta satisfactoria'
    });
  }
};
